import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const ND_LOGO = 'https://customer-assets.emergentagent.com/job_fa3535e7-5ebf-4005-b15d-2d6b7a3e39c7/artifacts/b3n5tlbb_kling_20260128_Image_to_Video_create_int_3479_0.gif';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Projects', path: '/projects' },
  { name: 'Impact', path: '/impact' },
  { name: 'Leadership', path: '/leadership' },
  { name: 'Events', path: '/events' },
  { name: 'Media', path: '/media' },
  { name: 'Contact', path: '/contact' }];


  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm shadow-sm">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img src={ND_LOGO} alt="NAIWA Daughters logo" className="w-12 h-12 rounded-xl object-cover shadow-sm" data-testid="header-logo-image" />
            <div className="flex flex-col">
              <span className="text-xl font-bold !text-[#7E2F22]" style={{ color: '#7e2f22' }}>NAIWA Daughters</span>
              <span className="text-xs" style={{ color: '#53a5ca' }}>Empowering Indigenous Leaders</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
              isActive(link.path) ?
              'text-white' :
              'text-gray-700 hover:bg-gray-100'}`
              }
              style={isActive(link.path) ? { backgroundColor: '#53a5ca' } : {}}>

                {link.name}
              </Link>
            )}
            <Link to="/support">
              <Button
                className="ml-4 text-white hover:opacity-90 transition-all duration-200"
                style={{ backgroundColor: '#e37c55' }}>

                Support Us
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu">

            {isMenuOpen ?
            <X className="h-6 w-6" style={{ color: '#7e2f22' }} /> :

            <Menu className="h-6 w-6" style={{ color: '#7e2f22' }} />
            }
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen &&
        <div className="lg:hidden mt-4 pb-4 space-y-2 border-t pt-4">
            {navLinks.map((link) =>
          <Link
            key={link.path}
            to={link.path}
            onClick={() => setIsMenuOpen(false)}
            className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
            isActive(link.path) ?
            'text-white' :
            'text-gray-700 hover:bg-gray-100'}`
            }
            style={isActive(link.path) ? { backgroundColor: '#53a5ca' } : {}}>

                {link.name}
              </Link>
          )}
            <Link to="/support" onClick={() => setIsMenuOpen(false)}>
              <Button
              className="w-full text-white mt-2"
              style={{ backgroundColor: '#e37c55' }}>

                Support Us
              </Button>
            </Link>
          </div>
        }
      </nav>
    </header>);

};

export default Header;